import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// Explicitly persist the Firebase Auth session in localStorage so the session
// survives tab closes and browser restarts. Without this, some environments
// (e.g. iOS PWA, private-browsing fallback) may default to session-only storage,
// causing owners and customers to be logged out unexpectedly.
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn("[KiranaOS] Could not set auth persistence:", err.message);
});